export const routes = {
  DEFAULT_BASE_REDIRECT: "/*",
  ROOT: "/web-app",
  DEFAULT_THROW: "/web-app/login",
  DEFAULT_WEB_REDIRECT: "web-app/*",
  SIGN_IN: "/login",
  SIGN_UP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  LOGOUT: "/logout",
  FORGOT_PASSWORD_VERIFICATION: "/forgot-password-verification",
  OTP_VERIFICATION: "/otp-verification",
  OTP_VERIFICATION_EMAIL: "/otp-verification-email",
  OTP_VERIFICATION_PHONE: "/otp-verification-phone",
  SET_NEW_PASSWORD: "/set-new-password",
  RESET_PASSWORD: "/reset-password",
  ADD_BANK_ACCOUNT: "/add-bank-account",
  UPDATE_BANK_ACCOUNT: "/update-bank-account",
  PROFILE_SETUP: "/profile-setup",
  UPDATE_PROFILE_SETUP: "/update-profile-setup",
  UPDATE_PROVIDER: "update-provider",
  UPDATE_STAFF: "update-staff",
  DASHBOARD: "/dashboard",
  SERVICES: "/services",
  CREATE_SERVICE: "/services/create-service",
  STAFF: "/staff",
  CREATE_STAFF: "/staff/create-staff",
  APPOINTMENT: "/appointment",
  CALENDAR: "/appointment/calendar",
  APPOINTMENTS_INFO: "/appointment/appointments-info",
  APPOINTMENTS_INFO_DETAILS:
    "/appointment/appointments-info/appointments-info-details",
  SERVICE_INFO_LIST: "/appointment/appointments-info/service-info-details",
  OFFERS_AND_PACKAGES: "/offers-and-packages",
  OFFER: "/offers-and-packages/offer",
  CREATE_OFFER: "/offers-and-packages/offer/create-offer",
  PACKAGES: "/offers-and-packages/packages",
  CREATE_PACKAGE: "/offers-and-packages/packages/create-package",
  REQUEST: "/request",
  PUSH_NOTIFICATION: "/push-notification",
  SEND_PUSH_NOTIFICATION: "/push-notification/send-push-notification",
  SENT_PUSH_NOTIFICATION_LIST: "/push-notification/sent-push-notification-list",
  STAFF_DASHBOARD: "/staff-dashboard",

  STAFF_APPOINTMENT: "/staff-appointment",
  STAFF_APPOINTMENT_INFO: "/staff-appointment/staff-appointment-info",
  STAFF_CALENDAR: "/staff-appointment/staff-calendar",
  FAQ: "/faq",
  LANGUAGES: "/languages",
  SETTINGS: "/settings",
  PROFILE_SETTINGS: "/profile-settings",
  STAFF_Chat: "/staff-chat",
  WALLET: "/wallet",
  WALLET_INFO: "/wallet/wallet-info",
  WALLET_TRANSACTION: "/wallet/wallet-transaction",
  CHAT: "/chat",
  USER_CHAT: "/chat/user-chat",
  STAFF_CHAT: "/chat/staff-chat",
  CHAT_REQUEST: "/chat/request",
  SERVICE_PROVIDER_CUSTOMER_DB: "/service-provider-customer-db",
  SERVICE_PROVIDER_CUSTOMER_INFO: "/service-provider-customer-db/customer-info",
  SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS:
    "/service-provider-customer-db/customer-info/customer-info-details",
  SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS_DETAILS:
    "/service-provider-customer-db/customer-info/customer-info-details/details",
  SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS_APPOINTMENTS:
    "/service-provider-customer-db/customer-info/customer-info-details/appointments",
    SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS_APPOINTMENTS_VIEW:
    "/service-provider-customer-db/customer-info/appointments/appointments-view",
  SUBSCRIPTIONS_AND_ADDONS: "/subscriptions-and-addons",
  SERVICE_PROVIDER_SUBSCRIPTIONS: "/subscriptions-and-addons/subscriptions",
  SERVICE_PROVIDER_SUBSCRIPTIONS_PLAN_HISTORY:
    "/subscriptions-and-addons/subscriptions-plan-history",
  SERVICE_PROVIDER_SUBSCRIPTIONS_ACTIVE_PLAN:
    "/subscriptions-and-addons/active-plan",
  ADDONS_AND_SPONSORSHIPS: "/addons-and-sponsorships",
  ADDONS_AND_SPONSORSHIPS_ADDON: "/addons-and-sponsorships/addon",
  ADDONS_AND_SPONSORSHIPS_ADDON_PLAN_HISTORY:
    "/addons-and-sponsorships/addon-plan-history",
  ADDONS_AND_SPONSORSHIPS_ORGANIZATION_SPONSORSHIP_HISTORY:
    "/addons-and-sponsorships/add-organization-sponsorship-history",
  ADDONS_AND_SPONSORSHIPS_PUSH_NOTIFICATION_HISTORY:
    "/addons-and-sponsorships/add-push-notification-history",
  SUBSCRIPTION_PAYMENT: "/subscription-payment",
  WALLET_PAYMENT: "/wallet-payment",
  GIFT_CARD: "/wallet/gift-card",
  GIFT_CARD_TRANSACTIONS: "/wallet/gift-card-transactions",
  PURCHASE_GIFT_CARD: "/wallet/gift-card/purchase-gift-card",
  ADDON_LOGIN_PAYMENT: "/addon-login-payment",
  GIFT_CARD_PAYMENT: "/gift-card-payment",
  OFFER_AND_PACKAGES_PAYMENT: "/offer-and-packages-payment",
  FINE_PAYMENT: "/fine-payment",
  PUSH_NOTIFICATION_PAYMENT: "/push-notification-payment",
  STAFF_RENEWAL_PAYMENT: "/staff-renewal-payment",
  SERVICE_PROVIDER_REVIEWS: "/service-provider-reviews",
  HELP_AND_SUPPORT: "/help-and-support",
  HELP_AND_SUPPORT_LIST: "/help-and-support/list",
  SERVICE_PROVIDER_REVIEW_INFO:
    "/service-provider-reviews/service-provider-review-info",
  SERVICE_PROVIDER_REVIEW_INFO_DETAILS:
    "/service-provider-reviews/service-provider-review-info/details",

  // Super admin routes
  SUPER_ADMIN_ROOT: "/web-app/super-admin",
  SUPER_ADMIN_DEFAULT_THROW: "/web-app/super-admin/login",
  DEFAULT_SUPER_ADMIN_WEB_REDIRECT: "web-app/super-admin/*",
  SUPER_ADMIN_SIGN_IN: "/login",
  SUPER_ADMIN_SIGN_UP: "/signup",
  SUPER_ADMIN_DASHBOARD: "/dashboard",
  CUSTOMER_DB: "/customer-db",
  CUSTOMER_INFO: "/customer-db/customer-info",
  CUSTOMER_INFO_DETAILS: "/customer-db/customer-info/customer-info-details",
  CUSTOMER_INFO_DETAILS_DETAILS:
    "/customer-db/customer-info/customer-info-details/details",
  CUSTOMER_INFO_DETAILS_APPOINTMENTS:
    "/customer-db/customer-info/customer-info-details/appointments",
  CUSTOMER_INFO_DETAILS_APPOINTMENTS_VIEW:
    "/customer-db/customer-info/appointments-view",
  SERVICE_PROVIDER: "/service-provider",
  SERVICE_PROVIDER_DETAILS: "/service-provider/service-provider-details",
  SERVICE_PROVIDER_DETAILS_DETAILS:
    "/service-provider/service-provider-details/details",
  SERVICE_PROVIDER_DETAILS_SERVICE_DETAILS:
    "/service-provider/service-provider-details/service-details",
  SERVICE_PROVIDER_DETAILS_APPOINTMENT_DETAILS:
    "/service-provider/service-provider-details/appointment-details",
  SERVICE_PROVIDER_DETAILS_SUBSCRIPTION_PAYMENT:
    "/service-provider/service-provider-details/subscription-payment",
  SERVICE_PROVIDER_DETAILS_OFFERS:
    "/service-provider/service-provider-details/offers",
  SERVICE_PROVIDER_DETAILS_STAFF:
    "/service-provider/service-provider-details/staff",
  SERVICE_PROVIDER_DETAILS_PACKAGES:
    "/service-provider/service-provider-details/packages",
  SALES_PAGE: "/sales-page",
  SALES_PAGE_APPOINTMENTS: "/sales-page/appointments",
  SALES_PAGE_APPOINTMENTS_DETAILS:
    "/sales-page/appointments/appointment-details",
  SALES_PAGE_CONFIGURATION: "/sales-page/configuration",
  SALES_PAGE_CONFIGURATION_LIST: "/sales-page/configuration/list",
  PRO_MEMBERSHIP: "/pro-membership",
  USER_MANAGEMENT: "/user-management",
  USER: "/user-management/user",
  PROVIDER: "/user-management/provider",
  FINE_CONFIG: "/user-management/fine-config",
  FINE_TANSACTION_HISTORY: "/user-management/fine-transaction-history",
  USER_MANAGEMENT_SERVICES: "/user-management/user-management-services",
  FUND_MANAGEMENT: "/fund-management",
  REVENUE: "/fund-management/revenue",
  PAYROLL: "/fund-management/payroll",
  PRICING_MODEL: "/fund-management/pricing-model",
  WALLET_MANAGEMENT: "/fund-management/wallet-management",
  ADD_WALLET_MANAGEMENT: "/fund-management/wallet-management/add-wallet",
  WALLET_TRANSACTIONS: "/fund-management/wallet-transactions",
  WALLETS_INFO: "/fund-management/wallets-info",
  CATEGORIES: "/categories",
  FAQS: "/faqs",
  FAQS_REVENUE: "/faqs/revenue",
  NOTIFICATION: "/notification",
  NOTIFICATION_REQUEST: "/notification/request",
  TERMS_AND_CONDITION: "/terms-and-conditions",
  REFERRAL_AND_DISCOUNT_CODES: "/referral-and-discount-codes",
  REFERRAL_CODE: "/referral-and-discount-codes/referral-code",
  REFERRAL_CODE_LIST: "/referral-and-discount-codes/referral-code/list",
  DISCOUNT_CODES: "/referral-and-discount-codes/gift-codes",
  ADD_DISCOUNT_CODES:
    "/referral-and-discount-codes/discount-codes/add-discount-codes",
  COUPON_CODES: "/referral-and-discount-codes/coupon-codes",
  ADD_COUPON_CODES: "/referral-and-discount-codes/coupon-codes/add-coupon-code",
  ADS_AND_ADDONS: "/ads-and-addons",
  ADS: "/ads-and-addons/ads",
  ADS_LIST: "/ads-and-addons/ads/ads-list",
  ADDONS: "/ads-and-addons/addons",
  ADDONS_LIST: "/ads-and-addons/addons/addons-list",
  ORGANIZATION_SPONSORSHIP: "/ads-and-addons/organization-sponsorship",
  ADD_ORGANIZATION_SPONSORSHIP: "/ads-and-addons/organization-sponsorship/add",
  REQUESTS: "/requests",
  SERVICE_PROVIDER_AUTH: "/requests/service-provider-auth",
  SERVICE_PROVIDER_AUTH_DETAILS:
    "/requests/service-provider-auth/service-provider-auth-details",
  LOGIN_AUTH: "/requests/login-auth",
  LOGIN_AUTH_DETAILS: "/requests/login-auth/login-auth-details",
  REVIEWS: "/reviews",
  REVIEW_INFO: "/reviews/review-info",
  REVIEW_CONFIG: "/reviews/review-config",
  VIEW_REVIEW_INFO: "/reviews/review-info/view",
  SUBSCRIPTIONS: "/subscriptions",
  ACTIVE_SUBSCRIPTION: "/subscriptions/active-subscription",
  ACTIVE_SUBSCRIPTION_UPDATE: "/subscriptions/active-subscription/update",
  INACTIVE_SUBSCRIPTION: "/subscriptions/inactive-subscription",
  SUBSCRIPTION_PLAN: "/subscriptions/subscription-plan",
  ELITE_PREMIUM: "/subscriptions/elite-premium",
  SUBSCRIPTION_PLAN_LIST: "/subscriptions/subscription-plan-list",
  PREMIUM: "/subscriptions/premium",
  FREE: "/subscriptions/free",
  AUTO_CREDIT: "/subscriptions/auto-credit",
  AUTO_CREDIT_LIST: "/subscriptions/auto-credit/list",
  NOTIFY: "/notify",
  TICKET_MANAGEMENT: "/ticket-management",
  EASTER: "/route/nest/find/me/happy-secret-signature",
  TICKET_MANAGEMENT_CHAT: "/ticket-management/chat",
  TICKET_MANAGEMENT_DETAILS: "/ticket-management/ticket-details",
  FLASH_MESSAGE: "/flash-message",
  USER_PERMISSIONS: "/user-permissions",
  CHAT_ACCESS: "/chat-access",
  CHAT_ACCESS_USER: "/chat-access/chat-access-user",
  CHAT_ACCESS_USER_CHAT: "/chat-access/chat-access-user/chat",
  CHAT_ACCESS_SERVICE_PROVIDER: "/chat-access/chat-access-service-provider",
  CHAT_ACCESS_CHAT_CONVERSATION: "/chat-access/chat-conversation",
  CHAT_ACCESS_CHAT_CONVERSATION_CHAT: "/chat-access/chat-conversation/chat",
  CHAT_ACCESS_SERVICE_PROVIDER_CHAT:
    "/chat-access/chat-access-service-provider/chat",
};

export const baseRouteMaker = (route) => {
  return routes.ROOT + route;
};

export const baseRouteMakerForSuperAdmin = (route) => {
  return routes.SUPER_ADMIN_ROOT + route;
};
